import React from "react";
import { slice, last, capitalize } from "lodash";

const getId = (key: string) => {
  const idPieces = key.split("_");
  if (!idPieces.length) {
    return "";
  }

  const prefixes = slice(idPieces, 0, idPieces.length - 1).map((id) =>
    capitalize(id)
  );
  const section = (last(idPieces) || "").toLowerCase();
  return `homepage${prefixes.join("")}_${section}`;
};

const DummyComponent = (props: { customId?: string }) => (
  <div id={getId(props.customId || "")} {...props} />
);

export default DummyComponent;
